/**
 * Breakpoint Constants
 *
 * Centralized breakpoint management for consistent responsive design
 * across the application. These breakpoints align with TailwindCSS defaults.
 */

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/**
 * Media query strings for CSS-in-JS or styled-components
 */
export const mediaQueries = {
  sm: `@media (min-width: ${BREAKPOINTS.sm}px)`,
  md: `@media (min-width: ${BREAKPOINTS.md}px)`,
  lg: `@media (min-width: ${BREAKPOINTS.lg}px)`,
  xl: `@media (min-width: ${BREAKPOINTS.xl}px)`,
  '2xl': `@media (min-width: ${BREAKPOINTS['2xl']}px)`,
} as const;

/**
 * Responsive range helpers
 */
export const mediaRanges = {
  mobile: `(max-width: ${BREAKPOINTS.md - 1}px)`, // 0-767px
  tablet: `(min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg - 1}px)`, // 768-1023px
  desktop: `(min-width: ${BREAKPOINTS.lg}px)`, // 1024px+
} as const;

/**
 * Device type classification based on viewport width
 */
export type DeviceType = 'mobile' | 'tablet' | 'desktop';

/**
 * Get device type from window width
 */
export function getDeviceType(width: number): DeviceType {
  if (width < BREAKPOINTS.md) return 'mobile';
  if (width < BREAKPOINTS.lg) return 'tablet';
  return 'desktop';
}
